import React from "react";

const BioReformCard = () => {
  const cards = [
    {
      image: "https://cdn.blackincae.com/37U-card-1-l-otto.png",
      text: "​Aid in the digestion of Lung Renew® nutrients.",
      italic: false,
    },
    {
      image: "https://cdn.blackincae.com/tPC-card-2-l-otto.png",
      text: "Make sure your body receives the minerals, vitamins, fats, and amino acids from the foods you eat...",
      italic: true,
    },
    {
      image: "https://cdn.blackincae.com/1v0-card-3-l-otto.png",
      text: "Help generate specific B vitamins, vitamin K, and folate, along with short-chain fatty acids.",
      italic: false,
    },
    {
      image: "https://cdn.blackincae.com/wnt-card-4-l-otto.png",
      text: "Contribute to proper lung immunity function.",
      italic: true,
    },
    {
      image: "https://cdn.blackincae.com/1rE-card-5-l-otto.png",
      text: "Enhance your energy, renew your vitality, and give you a healthy mood boost.",
      italic: false,
    },
    {
      image: "https://cdn.blackincae.com/LNl-card-6-l-otto.png",
      text: "Safeguard your healthy probiotic bacteria with MAKTrek® technology.",
      italic: true,
    },
  ];

  return (
    <>
      <div className="text-black flex items-center gap-4 justify-center pt-8 text-center">
        <div className="text-[20px] text-center max-w-xl px-4">
          The groundbreaking{" "}
          <span className="bold-font">MAKTrek® 3-D Probiotic</span> Delivery
          System guarantees these powerful probiotics reach their target.
        </div>
      </div>

      <div className="text-black flex items-center gap-4 justify-center pt-2">
        <div className="text-[20px] text-start max-w-lg text-[#233751] hidden md:block">
          A daily dose of{" "}
          <span className="text-[28px] font-bold bold-font">
            BioReform Probiotic
          </span>{" "}
          will:
        </div>
        <div className="text-[20px] text-center max-w-lg text-[#233751] block md:hidden">
          A daily dose of <br />
          <span className="text-[28px] font-bold bold-font">
            BioReform Probiotic
          </span>{" "}
          will:
        </div>
      </div>

      <div className="flex items-center justify-center">
        <div className="grid gap-4 md:grid-cols-3 grid-cols-1 mx-auto max-w-5xl px-3 pt-10">
          {cards.map((card, index) => (
            <div
              key={index}
              className="max-w-sm rounded-[10px] overflow-hidden shadow-lg bg-[#233751] flex flex-col group"
            >
              <div className="relative">
                <img
                  className="w-full transition-transform duration-300 ease-in-out group-hover:scale-105"
                  src={card.image}
                  alt=""
                />
                <div className="absolute bottom-[-10px] left-1/2 transform -translate-x-1/2 transition-all duration-300 ease-in-out group-hover:bottom-[-15.5px]">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="11"
                    viewBox="0 0 20 11"
                    fill="none"
                  >
                    <path
                      d="M0 0.899414C0 0.899414 4.43216 0.999919 9.8995 0.999919C15.3668 0.999919 19.799 0.899414 19.799 0.899414L9.89949 10.7989L0 0.899414Z"
                      fill="#AB7C3B"
                    />
                  </svg>
                </div>
              </div>
              <div className="px-6 py-6 flex md:flex-1 md:items-center">
                <p
                  className={`text-center md:text-start text-white font-bold text-[21px] ${
                    card.italic ? "italic" : ""
                  }`}
                >
                  {card.text}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default BioReformCard;
